import { Injectable } from "@angular/core";
import { tap } from "rxjs/operators";
import { Router,ActivatedRoute } from "@angular/router";
import { SharedService } from '../services/shared.service';
import { LoginService } from '../services/login.service';
import { AcpsharedService } from '../services/acpshared.service';

import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse
} from "@angular/common/http";

import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import 'rxjs/add/observable/empty';
import { Observable } from "rxjs/Observable";
@Injectable()
export class ApplnInterceptor implements HttpInterceptor {
  ulrAcp = 0;
  projectId:any;
  constructor(private router: Router,private route: ActivatedRoute,private sharedService: SharedService,private loginService: LoginService,private acpsharedService: AcpsharedService) {

    let urlString = location.pathname;
	  if(urlString.indexOf('/acp/') >=0 || urlString.indexOf('acp/') >=0){
      this.ulrAcp = 1;  
      this.acpsharedService.ACPProjectIdentifier.subscribe( value => {
        this.projectId = value;
      });
	  }
  }
    //function which will be called for all http calls
    intercept(
      request: HttpRequest<any>,
      next: HttpHandler
    ): Observable<HttpEvent<any>> {
      var idToken = "";
      if(this.ulrAcp == 1){
        var idToken = localStorage.getItem("acp_auth_token");
      }else{
        var idToken = localStorage.getItem("auth_token");
      }
    /*  //how to update the request Parameters
      const updatedRequest = request.clone({
        headers: request.headers.set("Authorization", idToken)
      }); */
    
    if (idToken) {
      request = request.clone({
        headers: request.headers.set("Authorization",
          "Bearer " + idToken)
      });
    }

        return next.handle(request)
          .catch((error, source) => {

              if (error instanceof HttpErrorResponse &&
                  error.status == 401) {
                    if(this.ulrAcp == 1){
                      localStorage.removeItem('acp_auth_token');
                      this.acpsharedService.IsACPUserLoggedIn.next(false);
                      this.acpsharedService.hasAcpAuthToken.next(false);
                      this.router.navigate(['/acp/'+this.projectId]);   
                    }else{
                      localStorage.removeItem('auth_token');
                      this.sharedService.IsUserLoggedIn.next(false);
                      this.router.navigate(["login"]);
                    }
                  return Observable.empty();
              }
              /*else {
                  return Observable.throw(error);
              }*/
          });
	/*return next.handle(request).pipe( tap(() => {},
      (err: any) => {
      if (err instanceof HttpErrorResponse) {
        console.log(err);
        if (err.status !== 401) {
          return;
        }
        localStorage.removeItem('auth_token');
        this.sharedService.IsUserLoggedIn.next(false);
        this.router.navigate(['login']);
        return Observable.empty();
      }
  }));*/
	
    /* //logging the updated Parameters to browser's console
    console.log("Before making api call : ", updatedRequest);
    return next.handle(request).pipe(
      tap(
        event => {
          //logging the http response to browser's console in case of a success
          if (event instanceof HttpResponse) {
            console.log("api call success :", event);
          }
        },
        error => {
          //logging the http response to browser's console in case of a failuer
          if (event instanceof HttpResponse) {
            console.log("api call error :", event);
          }
        }
      )
    ); */
  }
}